<ng-container *transloco="let t; read: 'employees'">
<ng-container *transloco="let te; read: 'employee'">
<ng-container *transloco="let s; read: 'settings'">
  <h2 class="mbm">{{ s('employees') }}</h2>
<ng-container *ngIf="vm$ | async as vm">
  <kendo-grid
    [data]="vm.employees"
    (remove)="showDeleteModal = $event.dataItem.id"
    [style.maxHeight.px]="600"
    [resizable]="true"

  >
    <ng-template kendoGridToolbarTemplate *ngIf="('Permissions.EmployeeRoles.Create' | permission)">
      <button 
        *permissionIf="'Permissions.Employees.Create'"
        kendoButton (click)="createEmployee()">{{ t('add') }}</button>
    </ng-template>
    <kendo-grid-column field="firstName" [title]="t('firstName')"> </kendo-grid-column>

    <kendo-grid-column field="lastName" [title]="t('lastName')"> </kendo-grid-column>

    <kendo-grid-column field="email" [title]="t('email')"> </kendo-grid-column>

    <kendo-grid-column field="employeeRole" [title]="t('employeeRole')">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.employeeRole?.name ?? t('noRole') }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="department" [title]="t('department')">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.department?.name ?? t('noDepartment') }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(min-width: 450px)"  field="flexTimeBalance" [title]="t('flexTimeBalance')" width="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span >{{ dataItem.flexTimeBalanceObj?.hours }}</span
        ><span> h</span>
        <span> {{ (dataItem.flexTimeBalanceObj?.minutes | number:'2.0')}}</span
        ><span> min</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(min-width: 450px)"  field="preWorkTimeBalance" [title]="t('preWorkTimeBalance')" width="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span >{{ dataItem.preWorkTimeBalanceObj?.hours }}</span
        ><span> h</span>
        <span> {{ (dataItem.preWorkTimeBalanceObj?.minutes | number:'2.0')}}</span
        ><span> min</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="vacationBalance" [title]="t('vacationBalance')">
    </kendo-grid-column>

    <kendo-grid-command-column
    [title]="t('action')"
    width="250"
    >
      <ng-template kendoGridCellTemplate let-employee>
        <button
          kendoButton primary="true"
          (click)="editEmployee(employee)"
          *ngIf="('Permissions.Employees.Update' | permission)"
          >{{ t('edit') }}</button>
        <button
          kendoGridRemoveCommand
          *ngIf="('Permissions.Employees.Delete' | permission)"
        >{{ t('remove') }}</button>
      </ng-template>
    </kendo-grid-command-column>
  </kendo-grid>
  <button
    class="mtm"
    kendoButton
    (click)="onlyActiveEmployeesSub$.next(!vm.onlyActiveEmployeesSub)"
    >{{vm.onlyActiveEmployeesSub ? t("showAll") : t("showOnlyActive")}}
  </button>
  <app-delete-confirm-dialog
    [opened]="!!showDeleteModal"
    [message]="te('deletionMessage')"
    (confirmed)="onDelete(showDeleteModal)"
    (cancelled)="showDeleteModal = null"
  ></app-delete-confirm-dialog>
</ng-container>
</ng-container>
</ng-container>
</ng-container>
